var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 18.3334C15.3525 18.3334 19.0834 14.6026 19.0834 10.0001C19.0834 5.39758 15.3525 1.66675 10.75 1.66675C6.14752 1.66675 2.41669 5.39758 2.41669 10.0001C2.41669 11.1492 2.65002 12.2442 3.07002 13.2401C3.30252 13.7901 3.41835 14.0651 3.43335 14.2734C3.44752 14.4817 3.38585 14.7101 3.26335 15.1676L2.41669 18.3334L5.58252 17.4867C6.04002 17.3642 6.26835 17.3034 6.47669 17.3168C6.68502 17.3318 6.96002 17.4476 7.51002 17.6801C8.53557 18.112 9.63723 18.3341 10.75 18.3334Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90661 10.3143L8.63244 9.4135C8.93827 9.0335 9.31577 8.68016 9.34661 8.1735C9.35327 8.046 9.26327 7.47266 9.08411 6.32516C9.01327 5.87433 8.59161 5.8335 8.22744 5.8335C7.75244 5.8335 7.51494 5.8335 7.27911 5.94183C6.98077 6.07766 6.67494 6.46016 6.60744 6.781C6.55411 7.03516 6.59411 7.21016 6.67327 7.56016C7.00827 9.046 7.79577 10.5135 9.01577 11.7343C10.2366 12.9543 11.7041 13.7418 13.1908 14.0768C13.5408 14.156 13.7149 14.196 13.9691 14.1427C14.2899 14.076 14.6724 13.7693 14.8091 13.471C14.9166 13.2352 14.9166 12.9977 14.9166 12.5227C14.9166 12.1577 14.8758 11.7368 14.4249 11.666C13.2774 11.486 12.7041 11.3968 12.5766 11.4035C12.0708 11.4335 11.7166 11.8118 11.3366 12.1177L10.4358 12.8427",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.d089f0ae49539ed231a53102ae4dc80e.svg";
export { ForwardRef as ReactComponent };